import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ParentStudentMappingCreateRequestDTO,
  ParentStudentMappingDTO,
  ParentStudentMappingUpdateRequestDTO,
  ParentStudentMappingList,
  ParentStudentMappingDeleteRequestDTO,
  ParentStudentMappingReadByIdRequestDTO,
  ParentStudentMappingReadByParentIdRequestDTO,
  ParentStudentMappingReadByStudentIdRequestDTO,
  ParentStudentMappingReadByClassIdRequestDTO
} from './parent-student-mapping.interface';
import {
  ParentStudentMapping_Create,
  ParentStudentMapping_Update,
  ParentStudentMapping_ReadAll,
  ParentStudentMapping_Delete,
  ParentStudentMapping_ReadById,
  ParentStudentMapping_ReadByParentId,
  ParentStudentMapping_ReadByStudentId,
  ParentStudentMapping_ReadByClassId
} from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class ParentStudentMappingService {

  constructor() { }

  http = inject(HttpClient);

  ParentStudentMapping_Create(data: ParentStudentMappingCreateRequestDTO): Observable<ParentStudentMappingDTO> {
    return this.http.post<ParentStudentMappingDTO>(ParentStudentMapping_Create,data);
  }

  ParentStudentMapping_Update(data: ParentStudentMappingUpdateRequestDTO): Observable<ParentStudentMappingDTO> {
    return this.http.post<ParentStudentMappingDTO>(ParentStudentMapping_Update,data);
  }

  ParentStudentMapping_ReadAll(): Observable<ParentStudentMappingList> {
    return this.http.get<ParentStudentMappingList>(ParentStudentMapping_ReadAll);
  }

  ParentStudentMapping_Delete(data: ParentStudentMappingDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ParentStudentMapping_Delete,data);
  }

  ParentStudentMapping_ReadById(
    data: ParentStudentMappingReadByIdRequestDTO): Observable<ParentStudentMappingDTO> {
    return this.http.post<ParentStudentMappingDTO>(ParentStudentMapping_ReadById,data);
  }

  ParentStudentMapping_ReadByParentId(
    data: ParentStudentMappingReadByParentIdRequestDTO): Observable<ParentStudentMappingList> {
    return this.http.post<ParentStudentMappingList>(ParentStudentMapping_ReadByParentId,data);
  }

  ParentStudentMapping_ReadByStudentId(
    data: ParentStudentMappingReadByStudentIdRequestDTO): Observable<ParentStudentMappingList> {
    return this.http.post<ParentStudentMappingList>(ParentStudentMapping_ReadByStudentId,data);
  }

  ParentStudentMapping_ReadByClassId(
    data: ParentStudentMappingReadByClassIdRequestDTO): Observable<ParentStudentMappingList> {
    return this.http.post<ParentStudentMappingList>(ParentStudentMapping_ReadByClassId,data);
  }
  
}
